import React from 'react';

export interface LogoProps {
  href?: string;
  variant?: 'desktop' | 'mobile';
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ 
  href = '/', 
  variant = 'desktop',
  className = ''
}) => {
  const logoSrc = require('../../../../assets/img/logo-branca.svg').default;

  const logoStyles = {
    height: variant === 'mobile' ? '40px' : '',
    width: 'auto',
    // Filtro laranja aplicado via CSS inline para garantir funcionamento
    filter: 'invert(48%) sepia(79%) saturate(2476%) hue-rotate(18deg) brightness(118%) contrast(119%)',
    transition: 'filter 0.3s ease'
  };

  return (
    <div className={`header__logo ${variant === 'mobile' ? 'mobile-variant' : ''} ${className}`}>
      <h1>
        <a href={href} aria-label="Ir para página inicial - Forluz">
          <img 
            src={logoSrc}
            alt="Forluz - Fundação Forluminas de Seguridade Social" 
            style={logoStyles}
            onError={(e) => {
              console.warn(`Erro ao carregar logo ${variant}:`, e);
              // Fallback para um logo alternativo se necessário
              e.currentTarget.style.display = 'none';
            }}
            onMouseEnter={(e) => {
              // Hover effect - laranja mais brilhante
              e.currentTarget.style.filter = 'invert(48%) sepia(79%) saturate(2476%) hue-rotate(18deg) brightness(130%) contrast(120%)';
            }}
            onMouseLeave={(e) => {
              // Volta ao laranja normal
              e.currentTarget.style.filter = 'invert(48%) sepia(79%) saturate(2476%) hue-rotate(18deg) brightness(118%) contrast(119%)';
            }}
          />
        </a>
      </h1>
    </div>
  );
};

export default Logo;